import { render, staticRenderFns } from "./kllk-backtop.vue?vue&type=template&id=a5ac29bc&scoped=true"
import script from "./kllk-backtop.vue?vue&type=script&lang=js"
export * from "./kllk-backtop.vue?vue&type=script&lang=js"
import style0 from "./kllk-backtop.vue?vue&type=style&index=0&id=a5ac29bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ac29bc",
  null
  
)

export default component.exports